import { SCHEDULER_SITES_FILTER } from '@/scheduler/util/cookies';
import { getPersistedFilter, makeStorageKey, persistFilter } from '@/scheduler/util/persistFilter';
import { UPDATE_SITE_FILTER } from '@/store/action-types';

import Cookies from 'js-cookie';
import { uniq } from 'lodash';

export function updateSiteFilter(payload) {
  return dispatch => {
    const deduped = uniq(payload);
    persistFilter(SCHEDULER_SITES_FILTER, deduped);

    return dispatch({
      type: UPDATE_SITE_FILTER,
      payload: deduped,
    });
  };
}

export const getKey = (location, userId) => `${SCHEDULER_SITES_FILTER}-${userId}-${location}`;

export const getInitialSitesFilter = () => getPersistedFilter(SCHEDULER_SITES_FILTER, ['all']);

export const hasPersistedSiteFilterPreference = () => {
  const storageKey = makeStorageKey(SCHEDULER_SITES_FILTER);
  const hasStoredPreference =
    localStorage.getItem(storageKey) || Cookies.get(storageKey) || Cookies.get(SCHEDULER_SITES_FILTER);

  if (!hasStoredPreference) {
    return false;
  }

  const persisted = getPersistedFilter(SCHEDULER_SITES_FILTER, ['all']);
  return !(persisted.length === 1 && persisted[0] === 'all');
};
